import { LocationService } from '@modules/location/location-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doFind({ commit, rootGetters }, id) {
      try {
        commit('FIND_STARTED');

        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage ).getManageModel()
        const record = await LocationService.find(id, manageInput);

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/location');
      }
    },

    async doCreate({ commit, dispatch, rootGetters }, values) {
      try {
        commit('CREATE_STARTED');

        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage ).getManageModel()
        await LocationService.create(values,manageInput);

        dispatch('subproperty/requirements/doFetch', {
          propertyId: currentManage.property.id,
          subpropertyId: currentManage.subproperty.id,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });
        commit('CREATE_SUCCESS');
        Message.success(i18n('entities.location.create.success'));
        routerAsync().go(-1);
        //routerAsync().push('/location');
      } catch (error) {
        Errors.handle(error);
        commit('CREATE_ERROR');
      }
    },

    async doUpdate({ commit, rootGetters }, { id, values }) {
      try {
        commit('UPDATE_STARTED');

        const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage ).getManageModel()
        await LocationService.update(id, values, manageInput);

        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.location.update.success'));
        routerAsync().go(-1);
        //routerAsync().push('/location');
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },
  },
};
